import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LocalstorageService } from './localstorage.service';

@Injectable({
  providedIn: 'root'
})
export class PreShiftGuardService {

  constructor(private router: Router, private localstorageService: LocalstorageService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean{
    let url: string = state.url;
    return this.verifyEmployee(url);
  }

  verifyEmployee(url: string){
    if(this.localstorageService.isAuthenticated()){

      return true;
    }
    //console.log('requestedUrl: ', this.localstorageService.requestedUrl);
    if (this.localstorageService.requestedUrl != '/screening/pre-shift')
      this.localstorageService.requestedUrl = '/screening-report';

    this.router.navigateByUrl('/verify/pre-shift');

    return false;
  }
}
